// © Microsoft Corporation. All rights reserved.

import { appEnvironment, Environment } from "@msnews/core";
import { init, getSdkEnv } from "./API";

const prodSdkUrl = "https://webxtsvc.microsoft.com/js/pack/xpaySubscription.js";
const intSdkUrl = "https://xpay-int.microsoft.com/js/pack/xpaySubscription.js";

let subscriptionContainerId: string;
export const getSubscriptionContainerId = () => subscriptionContainerId;

// SDK is already initialized if `subscriptionContainerId` has a value
const isAlreadyInitialized = (): boolean => !!subscriptionContainerId;

// `sdkLoaded` promise is resolved when the SDK source file is loaded
let sdkLoadedResolver: (value: boolean) => void;
export const sdkLoaded: Promise<boolean> = new Promise(resolve => {
    sdkLoadedResolver = resolve;
});

function getSdkUrl (): string {
    switch (appEnvironment.Environment) {
        case Environment.int:
        case Environment.int1:
        case Environment.intpr:
        case Environment.intpef:
            return intSdkUrl;
        case Environment.prod:
        default:
            return prodSdkUrl;
    }
}

export function initializeSubscriptionSdk () {
    if (!isAlreadyInitialized()) {
        const sdkScript = document.createElement("script");
        sdkScript.onload = () => {
            sdkLoadedResolver(true);
            init({
                env: getSdkEnv()
            });
        };
        sdkScript.src = getSdkUrl();
        sdkScript.defer = true;
        document.body.appendChild(sdkScript);

        subscriptionContainerId = "subscription-sdk-container";
        const subscriptionContainer = document.createElement("div");
        subscriptionContainer.id = subscriptionContainerId;
        document.body.appendChild(subscriptionContainer);
    }
}
